(()=>{
const manorRoot=document.querySelector("#fde-experience");
if(!manorRoot)return;
const comparison = manorRoot.querySelector('#comparison');
const range = manorRoot.querySelector('#compare-range');
function updateComparison(value) {
  range.value = value;
  comparison.style.setProperty('--split', value + '%');
  range.setAttribute('aria-valuetext', `${value}% original home, ${100 - value}% Front Door Edit Makeover`);
  manorRoot.querySelectorAll('[data-view]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.view === String(value))));
}
range.addEventListener('input', () => updateComparison(range.value));
manorRoot.querySelectorAll('[data-view]').forEach(button => button.addEventListener('click', () => updateComparison(button.dataset.view)));
updateComparison(50);
// Carry only existing campaign parameters. This preview installs no analytics tags.
const incoming = new URLSearchParams(location.search);
const allowed = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'msclkid'];
manorRoot.querySelectorAll('a[href^="https://"]').forEach(link => {
  const url = new URL(link.href);
  if (url.hostname === 'adoorn.com' || url.hostname.endsWith('.adoorn.com')) {
    allowed.forEach(key => { if (incoming.has(key)) url.searchParams.set(key, incoming.get(key)); });
    link.href = url.href;
  }
});

// Touch and keyboard alternative to the product-photo hover state.
manorRoot.querySelectorAll('.photo-toggle').forEach(button => {
  button.addEventListener('click', () => {
    const card = button.closest('.product');
    const showing = card.classList.toggle('show-makeover');
    button.setAttribute('aria-pressed', String(showing));
    button.textContent = showing ? 'View product photo' : 'View makeover detail';
  });
});

})();